export const walletAddressTruncate = (str: string) => {
  return str?.length > 10 ? `${str.substr(0, 6)}...${str.slice(-4)}` : str
}
